export default __webpack_public_path__ + "static/media/body_1_male.586e2a68.png";